import axios from 'axios';
import History from '@/components/history';
import Observer from '@/common/scripts/observer';
import ParametricFilter from './templates/filter';
import ParametricResult from './templates/result';
import {Utils} from '@/common/scripts/utils';

const observer = new Observer();

class Parametric {
    constructor(options) {
        this.options = options;
        this.element = options.element;

        this.filter = null;
        this.result = null;
        this.visualLink = this.element.querySelector('.j-visual__link') || null;
        this.bookedClass = '.j-parametric-filter__lock';
        this.hideState = 0;
    }

    init() {
        this._initFilter();
        this._initResult();
        this._initBooked();
    }

    /**
     * Инит фильтров
     * @private
     */
    _initFilter() {
        this.filter = new ParametricFilter({
            element: this.element,
            change : (reqType, addData) => {
                this._send(reqType, addData);
            }
        });

        this.filter.init();
    }

    /**
     * Инициализация результатов
     * @private
     */
    _initResult() {
        this.result = new ParametricResult({
            element   : this.element,
            changeSort: (data) => {
                this._send('sort', data);
            },
            clickMore: (data) => {
                this._send('more', data);
            }
        });

        this.result.init();
    }

    _initBooked() {
        const bookedButtons = Array.from(this.element.querySelectorAll(this.bookedClass));

        bookedButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const active = !button.classList.contains('is-hide');

                this.hideState = active ? 1 : 0;

                this._send('booked');

                button.classList.toggle('is-hide');

                if (active) {
                    button.querySelector('.j-button__tooltip').innerText = 'Показать забронированные';
                } else {
                    button.querySelector('.j-button__tooltip').innerText = 'Скрыть забронированные';
                }
            });
        });
    }

    /**
     * Запрос на сервер
     * @param {string} reqType - тип запроса
     * @private
     */
    /* eslint-disable */
    _send(reqType, additionalData = {}) {
        const form = this.filter.getForm();

        const formData = form && Utils.isElement(form) ? new FormData(form) : new FormData();

        // Если производим скрытие / показ забронированных то на бек отправляем как фильтрацию, а на фронте обрабатываем как бронирование
        formData.append('request_type', reqType === 'booked' ? 'filter' : reqType);
        formData.append('hideState', this.hideState);
        formData.append('constr', form.dataset.appendConstr || false);
        formData.append('banner', form.dataset.appendBanner || false);
        
        if (form.dataset.appendConstrIndex) {
            formData.append('constr_index', form.dataset.appendConstrIndex);
        }

        this._addAdditionalData(formData, additionalData);

        if (!Utils.isElement(form)) {
            const exact = ['action', 'method'];

            for (const key in form) {
                if (Object.prototype.hasOwnProperty.call(form, key) && exact.indexOf(key) === -1) {
                    formData.append(key, form[key]);
                }
            }
        }

        this.filter.convertRanges(formData);

        // Действия перед отправкой запроса
        switch (reqType) {
            case 'filter':
                this.filter.runLoading(true);
                this.result.runLoading();
                this._resetUrl();
                History.appendFromFormData(formData);
                break;
            case 'reset':
                this._resetUrl();
                this.filter.runLoading(true);
                this.result.runLoading();
                this._setVisualLink();
                break;
            case 'show':
                this._resetUrl();
                this.filter.runLoading();
                this.result.runLoading();
                History.appendFromFormData(formData);
                this._setVisualLink();
                break;
            case 'sort':
                this.result.runLoading();
                break;
            case 'more':
                this._addDataFromUrlParams(formData);
                this.result.runLoading();
                break;
            case 'booked':
                this.result.runLoading();
                break;
            default:
                break;
        }

        // Hidden params
        formData.append('ts', form.dataset.appendTs || '');
        formData.append('st', form.dataset.appendSt || '');

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios[form.method](form.action, formData)
            .then((response) => {
                const {data, success, messages} = response.data;

                if (!success) {
                    throw new Error(messages.length ? messages : 'Ошибка на сервере');

                    return;
                }

                const searchParams = new URLSearchParams(formData).toString();

                switch (reqType) {
                    case 'sort':
                        this.result.setMoreResult(data, true);
                        this.result.setTotal(data.total);
                        break;
                    case 'more':
                        this.result.setMoreResult(data);
                        break;
                    case 'filter':
                        this.filter.setFilter(data, reqType);
                        this.result.setResult(data);
                        // this.result.scrollToTop();
                        break;
                    case 'reset':
                        this.filter.setFilter(data, reqType);
                        this.result.setResult(data);
                        // this.result.scrollToTop();
                        observer.publish('parametric:filterReset');
                        break;
                    case 'show':
                        this.filter.setResult();
                        this.result.setResult(data);
                        // this.result.scrollToTop();
                        break;
                    case 'booked':
                        this.filter.setResult();
                        this.result.setResult(data);
                        // this.result.scrollToTop();
                        break;
                    default:
                        break;
                }

                observer.publish('favorite:reInit');
            })
            /* eslint-disable */
            .catch((error) => {
                console.error(error);
            })
            /* eslint-enable */
            .then(() => {
                this.filter.stopLoading();
                this.result.stopLoading();
            });
    }
    /* eslint-enable */


    /**
     * Добавляет дополнительные данные в данные для отправки
     * @param {object} formData - formData
     * @param {object} data - объект доп. данных (может содержать объект данных формы)
     * @private
     */
    _addAdditionalData(formData, data) {
        if (!data) {
            return;
        }

        Object.keys(data).forEach((key) => {
            if (data[key] instanceof FormData) {
                data[key].forEach((v, k) => {
                    formData.append(k, v);
                });
            } else if (data[key] instanceof Array) {
                data[key].forEach((el) => {
                    formData.append(key, el);
                });
            } else {
                formData.append(key, data[key]);
            }
        });
    }

    /**
     * Добавляет параметры из адресной строки
     * @param {object} formData - formData
     * @private
     */
    _addDataFromUrlParams(formData) {
        const params = Utils.getAllUrlParams();

        Object.keys(params).forEach((key) => {
            if (!formData.has(key)) {
                formData.append(key, params[key]);
            }
        });
    }

    /**
     * Очищает url от параметров
     * @private
     */
    _resetUrl() {
        History.clear();
    }

    _setVisualLink() {
        if (!this.visualLink) {
            return;
        }

        const visualParams = this.filter.getVisualParams();
        const baseVisualLink = this.visualLink.getAttribute('href').split('?')[0];

        this.visualLink.href = visualParams.length ? `${baseVisualLink}?${visualParams}` : baseVisualLink;
    }
}

export default Parametric;
